import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const YouTube = (props) => {
  const [showMe, setShowMe] = useState(false);

  const showYouTube = () => {
    setTimeout(() => {
      setShowMe(true);
    }, 10);
  };

  useEffect(() => {
    window.addEventListener('scroll', showYouTube);
    return () => {
      window.removeEventListener('scroll', showYouTube);
    };
  });

  return (
    showMe && (
      <div className="youTubeContainer text-align-center">
        <h2 className="youTubeVedioHeader">{props.vedio.title}</h2>
        <iframe
          src={`https://www.youtube.com/embed/${props.vedio.vedioId}?rel=0`}
          frameBorder="0"
          width="1018"
          height="600"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="youTubeVedio"
        />
        <p className="text-align-center text-color-link">
          <span>{props.vedio.vedioMessage}</span>
          {props.vedio.productAdv && (
            <h4 className="vedioAdvLink">
              <a
                href={props.vedio.productAdv.productLink}
                data-wa-link={`${props.vedio.productAdv.productText}:${props.vedio.productAdv.productLink}`}
              >
                {props.vedio.productAdv.productText}
              </a>
            </h4>
          )}
        </p>
      </div>
    )
  );
};

YouTube.propTypes = {
  vedio: PropTypes.object,
};

export default YouTube;
